// extracted by mini-css-extract-plugin
module.exports = {"tabs":"step-1_tabs__2gSKa","tab":"step-1_tab__3Atza","active":"step-1_active__3fM7s","subtitle":"step-1_subtitle__3hdvd"};